'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-env node, browser */

var YBase = function (_React$Component) {
	_inherits(YBase, _React$Component);

	function YBase() {
		_classCallCheck(this, YBase);

		return _possibleConstructorReturn(this, (YBase.__proto__ || Object.getPrototypeOf(YBase)).apply(this, arguments));
	}

	_createClass(YBase, [{
		key: '_refCallback',
		value: function _refCallback(name, c) {
			this[name] = c;
		}
	}, {
		key: '_userHandler',
		value: function _userHandler(handlerName) {
			var eventObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			if (this.props[handlerName]) {
				return this.props[handlerName](eventObject);
			}
		}
	}, {
		key: 'setStatePromise',
		value: function setStatePromise(newState) {
			var _this2 = this;

			return new Promise(function (resolve) {
				_this2.setState(newState, function () {
					resolve();
				});
			});
		}
	}], [{
		key: 'getTld',
		value: function getTld() {
			var tld = location.hostname.split('.').pop();
			return tld === 'tr' ? 'com.tr' : tld;
		}
	}, {
		key: 'getDimension',
		value: function getDimension(obj) {
			if (!(obj instanceof HTMLElement)) {
				throw new Error('Wrong type of ' + (obj.type || obj) + '. getDimension accepts only DOM Node.');
			}

			var rect = obj.getBoundingClientRect();

			rect.offsetTop = rect.top + window.pageYOffset + document.documentElement.clientTop;
			rect.offsetLeft = rect.left + window.pageXOffset + document.documentElement.clientLeft;

			return rect;
		}
	}, {
		key: 'hasParent',
		value: function hasParent(el, parent) {
			if (!el) {
				return false;
			}

			if (el === parent) {
				return true;
			}

			while ((el = el.parentNode) && el !== document) {
				if (el === parent) {
					return true;
				}
			}

			return false;
		}
	}]);

	return YBase;
}(_react2.default.Component);

exports.default = YBase;